
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/caratGuide",
      function () {
        return require("private-next-pages/education/caratGuide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/caratGuide"])
      });
    }
  